// The updated source data now lives in the `fao-dwh` project, which we can read but not
// write to, so the views that read it are recreated in `fao-dwh-review.fao_cca_dwh`
// (same project as before, new dataset) while the originals in `fao_cca` stay untouched
// as a fallback.
//
// The view NAME is deliberately identical in both datasets: several places derive the
// data source label from it (CountryDetail.jsx strips the `vw_` prefix, BulkDownload.jsx
// takes the last `_` segment) and that label ends up in the FAOSTAT link and citation
// built by getLinkDetails. Renaming the views would break those.
const LEGACY_DATASET = "fao_cca";
const DWH_DATASET = "fao_cca_dwh";

// Of the 27 views whose only source is the `faostat` dataset, these 20 run unchanged
// against the restructured tables in fao-dwh. The other 7 (vw_ae, vw_cisp, vw_et,
// vw_fs, vw_hces, vw_sua, vw_wcad) hit columns that were renamed, dropped or made
// ambiguous and have to be rewritten one by one -- scripts/migrate-views-to-dwh.sql
// lists what changed for each. Until then they keep reading fao_cca, which is what
// leaving them out of this list does.
//
// vw_sdg_full is absent for a different reason: it reads faostat together with
// fao_un_sdg and fao_common_dimensions, which are not moving, and is owned elsewhere.
const FAOSTAT_VIEWS = [
    "vw_cahd", "vw_cp", "vw_ei", "vw_em", "vw_esb", "vw_fbs", "vw_fo", "vw_gt",
    "vw_ig", "vw_mk", "vw_oa", "vw_oea", "vw_oer", "vw_qcl", "vw_qv", "vw_rfn",
    "vw_rl", "vw_rp", "vw_sdgb", "vw_tcl",
];

// Views already recreated and verified in fao_cca_dwh. Empty = nothing changes, the
// dashboard keeps reading fao_cca. Switch all 27 over with `new Set(FAOSTAT_VIEWS)`,
// or migrate in batches with e.g. `new Set(["vw_qcl", "vw_sua"])`. Removing a name
// rolls that single view back to the old dataset.
export const DWH_VIEWS = new Set(FAOSTAT_VIEWS);

// `domain_code` in mockData.js is a fully qualified BigQuery name (project.dataset.view)
// interpolated straight into the FROM clause of the generated SQL.
export const resolveDomainCode = (domainCode) => {
    if (!domainCode) return domainCode;

    const parts = domainCode.split(".");
    if (parts.length !== 3) return domainCode;

    const [project, dataset, view] = parts;
    if (dataset !== LEGACY_DATASET || !DWH_VIEWS.has(view)) return domainCode;

    return `${project}.${DWH_DATASET}.${view}`;
};
